export const ssnFieldManagerConfigDefaults = {
    compactClass: 'fs-form-field--compact',
    dangerouslyDisablePatternValidation: false,
    hideMessage: 'Hide social security number',
    maskedCharacter: '•',
    separator: '-',
    showMessage: 'Show social security number',
    useMaskedValue: false
};
//# sourceMappingURL=types.js.map